import React from 'react';
import {Route} from 'react-router-dom';
import AsyncPrivacy from './async';
import BlankLayout from '../../../../components/layout/BlankLayout';

export default (
  <Route key="/business/privacy" element={<BlankLayout />}>
    <Route path="business/privacy" element={<AsyncPrivacy />} />
  </Route>
);
